import { createFeatureSelector, createSelector } from '@ngrx/store'
import { StoreKeysEnum } from '../../../../../store/store-keys'
import { ILiberatedAreaState } from './liberated-area.reducers'
import cloneDeep from 'lodash/cloneDeep'

export const selectLiberatedAreaFeature = createFeatureSelector<Readonly<ILiberatedAreaState>>(StoreKeysEnum.AdminLiberatedArea)

export const selectLiberatedAreaFilterCriteria = createSelector(
    selectLiberatedAreaFeature,
    feature => ({ ...feature.filterCriteria })
)

export const selectAllItemCollection = createSelector(
    selectLiberatedAreaFeature,
    feature => cloneDeep(feature.allItemCollection)
)

export const selectItemCollection = createSelector(
    selectLiberatedAreaFeature,
    feature => cloneDeep(feature.itemCollection)
)

export const selectLiberatedAreaComponentState = createSelector(
    selectItemCollection,
    selectLiberatedAreaFilterCriteria,
    (itemCollection, filterCriteria) => ({itemCollection, filterCriteria})
)